import "./index.css";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { store, persistor} from "./store/store";
import "./components/Translator";

const rootElement = document.getElementById("root");
if (rootElement === null) throw new Error('Root container missing in index.html');

const root = ReactDOM.createRoot(rootElement);

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Suspense fallback="Loading">
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            </Suspense>
        </PersistGate>
    </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
